// extracted by mini-css-extract-plugin
export var bar = "style-module--bar--39fdb";
export var chartComparison = "style-module--chartComparison--7adec";
export var leftTh = "style-module--leftTh--7e945";
export var qlSectionTitle = "style-module--qlSectionTitle--2ae95";
export var specContainer = "style-module--specContainer--cb05a";
export var subTitle = "style-module--subTitle--50056";
export var version = "style-module--version--6ac19";